import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Building2,
  Hospital,
  Home,
  HeartHandshake,
  ArrowRight,
} from "lucide-react";

const clients = [
  {
    title: "Hospitals",
    icon: Hospital,
  },
  {
    title: "Clinics",
    icon: Building2,
  },
  {
    title: "Home Care",
    icon: Home,
  },
  {
    title: "Individuals",
    icon: HeartHandshake,
  },
];

const CTASection = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="max-w-7xl mx-auto grid lg:grid-cols-2 rounded-3xl overflow-hidden shadow-xl"
      >
        {/* LEFT SECTION */}
        <div className="relative bg-green-600 px-8 lg:px-12 py-8 overflow-hidden">
          {/* Decorative circles */}
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-white/10" />
          <div className="absolute -bottom-24 -left-20 w-80 h-80 rounded-full bg-white/10" />

          <div className="relative z-10">
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight">
              Ready to Find the Right Healthcare Equipment?
            </h2>

            <p className="mt-6 text-lg text-green-50 leading-relaxed">
              Whether you're purchasing for a hospital, clinic, or home care,
              AfyaEquip provides trusted healthcare equipment that meets your
              needs with quality and reliability.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/shop"
                className="group flex items-center gap-3 bg-white text-black px-7 py-3 rounded-full font-medium transition duration-300 shadow-lg hover:bg-transparent hover:text-white border border-white"
              >
                <span>Shop Equipment</span>

                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-green-600 text-white transition duration-300 group-hover:bg-white group-hover:text-green-600">
                  <ArrowRight size={18} />
                </span>
              </Link>

              <Link
                to="/contact"
                className="border border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-green-700 transition"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="bg-white px-8 lg:px-12 py-8 flex flex-col justify-center">
          <span className="text-green-600 font-semibold uppercase tracking-wide">
            Who We Serve
          </span>

          <div className="grid grid-cols-2 gap-5 mt-10">
            {clients.map((client, index) => {
              const Icon = client.icon;

              return (
                <div
                  key={index}
                  className="border border-gray-200 rounded-2xl p-2 text-center hover:border-green-600 hover:shadow-md transition"
                >
                  <div className="mx-auto w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-4">
                    <Icon size={28} className="text-green-600" />
                  </div>

                  <h4 className="font-semibold text-gray-900">
                    {client.title}
                  </h4>
                </div>
              );
            })}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
